<template>
  <div>
    <div class="row">
      <div class="col-lg-5">
        <b-form-group>
          <b-input-group size="md">
            <b-form-input
              v-model="pagination.filter"
              :placeholder="$t('PAGE.DEFAULT.TABLE.SEARCH')"
              type="search"
              id="filterInput"
              debounce="500"
              @update="searchFilter()"
            ></b-form-input>
            <b-input-group-append>
              <b-button
                :disabled="!pagination.filter"
                @click="
                  pagination.filter = '';
                  searchFilter();
                "
                >{{ $t("PAGE.DEFAULT.TABLE.CLEAR") }}</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
      <div class="col-lg-7">
        <b-button
          class="float-right"
          variant="primary"
          @click="downloadData()"
          :disabled="items.length == 0"
        >
          <b-icon icon="file-earmark-text"></b-icon>
          {{
            $t(
              "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.DOWNLOADEXCEL"
            )
          }}
        </b-button>
      </div>

      <div class="col-lg-12 pb-5">
        <div class="row">
          <div class="col-lg-3 col-xxl-3">
            <div class="row">
              <div class="col-lg-1 col-xxl-1 align-center">
                <label for="" align-self="center">
                  {{
                    $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.FROM")
                  }}
                </label>
              </div>
              <div class="col-lg-11 col-xxl-11">
                <date-picker v-model="from" :config="options"></date-picker>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-xxl-3">
            <div class="row">
              <div class="col-lg-1 col-xxl-1 align-center">
                <label for="">{{
                  $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.TO")
                }}</label>
              </div>
              <div class="col-lg-11 col-xxl-11">
                <date-picker v-model="to" :config="options"></date-picker>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-xxl-3">
            <div class="row">
              <div class="col-lg-1 col-xxl-1 align-center">
                <label for="">{{
                  $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.STATUS")
                }}</label>
              </div>
              <div class="col-lg-11 col-xxl-11">
                <b-form-select
                  v-model="filter_is_approve"
                  id="is-approve-filter"
                  :options="filter_approval_list"
                ></b-form-select>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-xxl-3 pt-5">
            <b-button
              block
              class="float-right"
              type="submit"
              variant="primary"
              @click.prevent="searchFilter()"
            >
              {{
                $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.SEARCH")
              }}
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <div class="table-content">
      <div class="table-responsive">
        <b-table
          id="organizations-table"
          :striped="false"
          :small="true"
          :items="items"
          :fields="tableFields"
          :sort-by.sync="pagination.orderBy"
          :sort-desc.sync="pagination.isDesc"
          :no-sort-reset="true"
          :no-local-sorting="true"
          :busy.sync="isBusy"
          :loading="false"
          :borderless="false"
          head-variant="light"
          @sort-changed="sortChange"
        >
          <template #cell(id)="data">
            <div class="text-right">
              <span v-if="pagination.isDesc">{{
                total -
                (pagination.perPage * (pagination.page - 1) + data.index)
              }}</span>
              <span v-if="!pagination.isDesc">
                {{
                  pagination.perPage * (pagination.page - 1) + data.index + 1
                }}
              </span>
            </div>
          </template>

          <!-- point_grant = Staff สแกน QR ของสมาชิกแล้วแจกแต้ม -->
          <template #cell(customer_campaign_receipt.type)="data">
            {{ data.item.type === "point_grant" ? "สแกน QR ให้แต้ม" : "ใบเสร็จ" }}
          </template>

          <template #cell(customer_campaign_receipt.is_approve)="data">
            <span v-if="data.item.is_approve == 0" class="text-warning">{{
              $t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.WAITING_APPROVE")
            }}</span>
            <span v-else-if="data.item.is_approve == 1" class="text-success">{{
              $t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.APPROVED")
            }}</span>
            <span v-else>{{
              $t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.UNAPPROVED")
            }}</span>
          </template>

          <template #cell(customer_campaign_receipt.point)="data">
            <div class="text-right">
              <span v-if="data.item.point">{{ data.item.point }}</span>
              <span v-else>-</span>
            </div>
          </template>

          <!-- รายการจาก Staff ไม่มีรหัสตรวจสอบ แสดงเลขที่ใบเสร็จที่สมาชิกกรอกตอนสร้าง QR แทน -->
          <template #cell(customer_campaign_receipt.verify_code)="data">
            <span v-if="data.item.verify_code">{{
              data.item.verify_code
            }}</span>
            <span v-else-if="data.item.type === 'point_grant'">{{
              data.item.ocr_receipt_number || "-"
            }}</span>
            <span v-else>-</span>
          </template>

          <template #cell(bank_name)="data">
            <span>{{ getRowBankName(data.item) }}</span>
          </template>

          <template #cell(customer_campaign_receipt.remark)="data">
            <span v-if="data.item.remark">{{ data.item.remark }}</span>
            <span v-else>-</span>
          </template>

          <template #cell(action)="data">
            <a
              href="javascript:"
              @click.prevent="openFormModal(data.item.id)"
              class="btn btn-icon btn-light btn-sm"
            >
              <span class="svg-icon svg-icon-md svg-icon-success">
                <inline-svg
                  src=" media/svg/icons/General/Edit.svg"
                ></inline-svg>
              </span>
            </a>
          </template>
        </b-table>

        <p class="text-center pt-3" v-if="items.length < 1">
          {{ $t("PAGE.DEFAULT.TABLE.DATA_NOT_FOUND") }}
        </p>
      </div>

      <div class="row justify-content-between">
        <div div class="col-lg-3">
          <b-form-group
            id="name-input-group"
            :label="$t('PAGE.DEFAULT.TABLE.PER_PAGE')"
            label-for="name-input"
            label-cols="5"
            label-align-sm="left"
            label-size="lg"
          >
            <b-form-select
              v-model="pagination.perPage"
              id="perPageSelect"
              size="sm"
              :options="paginationOptions"
              @change="fetchData()"
            ></b-form-select>
          </b-form-group>
        </div>

        <div div class="col-lg-6">
          <b-pagination
            v-model="pagination.page"
            :total-rows="total"
            :per-page="pagination.perPage"
            @input="fetchData()"
            align="right"
          ></b-pagination>
        </div>
      </div>
    </div>

    <div class="form-modal">
      <b-modal
        size="xl"
        id="modal-form"
        ref="modal"
        :title="this.$t('PAGE.CAMPAIGN.FORM.MODAL.CUSTOMER_RECEIPT')"
        :ok-title="this.$t('PAGE.DEFAULT.FORM.BTN_SUBMIT')"
        :ok-disabled="is_checking_verify_code"
        :cancel-title="this.$t('PAGE.DEFAULT.FORM.BTN_CANCEL')"
        @ok="handleSubmit"
      >
        <form ref="form" @submit.stop.prevent="handleSave">
          <b-row class="mb-1 text-center">
            <b-col class="col-image">
              <b-row id="ccr-recepit-image" class="mb-5">
                <b-col sm="12 text-center">
                  <!-- รายการจาก Staff ที่สมาชิกไม่แนบรูปเก็บเป็น '' ปล่อยว่าง ไม่แสดงรูปแตก -->
                  <a
                    v-if="form.receipt_image"
                    :href="form.receipt_image"
                    target="_blank"
                  >
                    <img
                      :src="form.receipt_image"
                      class="receipt-image"
                      alt="Receipt image"
                    />
                  </a>
                </b-col>
              </b-row>
            </b-col>
            <b-col class="col-form">
              <b-row id="ccr-customer" class="mb-5">
                <b-col sm="4">
                  <label>
                    <h5>
                      {{
                        $t(
                          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.CUSTOMER"
                        )
                      }}
                    </h5>
                  </label>
                </b-col>

                <b-col sm="8">
                  <b-form-input
                    id="customer-input"
                    name="customer-input"
                    v-model="form.customer_fullname"
                    disabled
                  ></b-form-input>
                </b-col>
              </b-row>

              <b-row
                v-if="paymentTypeDisplay"
                id="ccr-payment-type"
                class="mb-5"
              >
                <b-col sm="4">
                  <label>
                    <h5>ประเภทการชำระเงิน</h5>
                  </label>
                </b-col>

                <b-col sm="8">
                  <b-form-input
                    id="payment-type-input"
                    name="payment-type-input"
                    :value="paymentTypeDisplay"
                    disabled
                  ></b-form-input>
                </b-col>
              </b-row>

              <b-row
                id="ccr-receipt-type"
                v-if="is_redeem_reward == 0"
                class="mb-5"
              >
                <b-col sm="4">
                  <label>
                    <h5>
                      {{
                        $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.REWARD")
                      }}
                    </h5>
                  </label>
                </b-col>

                <b-col sm="8">
                  <b-form-input
                    id="receipt-type-input"
                    name="receipt-type-input"
                    v-model="form.reward_name"
                    disabled
                  ></b-form-input>
                </b-col>
              </b-row>

              <b-row
                v-if="!isTransferSlip"
                id="ccr-receipt-type"
                class="mb-5"
              >
                <b-col sm="4">
                  <label>
                    <h5>
                      {{
                        $t(
                          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.RECEIPT_TYPE"
                        )
                      }}
                    </h5>
                  </label>
                </b-col>

                <b-col sm="8">
                  <b-form-select
                    v-model="form.receipt_type_id"
                    id="receipt-type-input"
                    :options="receipt_type_list"
                    :disabled="isPointGrant"
                  ></b-form-select>
                </b-col>
              </b-row>

              <b-row v-if="isTransferSlip" id="ccr-bank" class="mb-5">
                <b-col sm="4">
                  <label>
                    <h5>ธนาคาร</h5>
                  </label>
                </b-col>

                <b-col sm="8">
                  <b-form-select
                    id="bank-input"
                    name="bank-input"
                    v-model="form.bank_code"
                    :options="master_banks"
                    :disabled="isPointGrant"
                  >
                    <template #first>
                      <b-form-select-option :value="null">
                        - เลือกธนาคาร -
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                </b-col>
              </b-row>

              <b-row id="ccr-is-approve" class="mb-5">
                <b-col sm="4">
                  <label>
                    <h5>
                      {{
                        $t(
                          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.IS_APPROVE"
                        )
                      }}
                    </h5>
                  </label>
                </b-col>

                <b-col sm="8">
                  <b-form-select
                    v-model="form.is_approve"
                    id="is-approve-input"
                    :options="approval_list"
                    @change="checkNotApprove($event)"
                    :disabled="is_approve || isPointGrant"
                  ></b-form-select>
                </b-col>
              </b-row>

              <b-row
                id="ccr-unapproved_reason"
                class="mb-5 text-left"
                v-if="is_select_not_approve"
              >
                <b-col sm="4">
                  <label>
                    <h5>
                      {{
                        $t(
                          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.REASON_NOT_APPROVE"
                        )
                      }}
                    </h5>
                  </label>
                </b-col>

                <b-col sm="8">
                  <b-form-group>
                    <b-form-radio-group
                      v-model="form.unapproved_reason_id"
                      :options="option_radio"
                      name="radios-stacked"
                      @change="checkOtherReason($event)"
                      stacked
                      :disabled="is_approve || isPointGrant"
                    >
                    </b-form-radio-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row
                id="ccr-unapproved_reason_remark"
                class="mb-5"
                v-if="is_select_not_approve && is_select_reason_other"
              >
                <b-col sm="4">
                  <label>
                    <h5>
                      {{
                        $t(
                          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.UNAPPROVED_REASON_REMARK"
                        )
                      }}
                    </h5>
                  </label>
                </b-col>

                <b-col sm="8">
                  <b-form-textarea
                    id="remark-input"
                    name="remark-input"
                    v-model="form.unapproved_reason_remark"
                    rows="3"
                    max-rows="6"
                    :disabled="is_approve || isPointGrant"
                  ></b-form-textarea>
                </b-col>
              </b-row>

              <b-row id="ccr-point" class="mb-5">
                <b-col sm="4">
                  <label>
                    <h5>
                      {{
                        $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.POINT")
                      }}
                    </h5>
                  </label>
                </b-col>

                <b-col sm="8">
                  <b-form-input
                    type="number"
                    @wheel="$event.target.blur()"
                    @keypress="isNumber($event)"
                    id="point-input"
                    name="point-input"
                    v-model="$v.form.point.$model"
                    :state="validateState('point')"
                    :disabled="isPointGrant"
                    aria-describedby="name-live-feedback"
                  ></b-form-input>

                  <b-form-invalid-feedback id="name-live-feedback">
                    <span v-if="!$v.form.point.required" class="error">
                      {{ $t("PAGE.DEFAULT.FORM.VALIDATION.REQUIRED") }}
                    </span>
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>

              <b-row id="ccr-verify-code" class="mb-5">
                <b-col sm="4">
                  <label>
                    <h5>
                      {{
                        $t(
                          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.VERIFY_CODE"
                        )
                      }}
                    </h5>
                  </label>
                </b-col>

                <b-col sm="8">
                  <b-form-input
                    id="verify-code-input"
                    name="verify-code-input"
                    @keyup="handleVerifyCodeExist($event)"
                    v-model="form.verify_code"
                    :disabled="isPointGrant"
                  ></b-form-input>
                </b-col>
              </b-row>

              <b-row id="ccr-remark" class="mb-5">
                <b-col sm="4">
                  <label>
                    <h5>
                      {{
                        $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.FIELDS.REMARK")
                      }}
                    </h5>
                  </label>
                </b-col>

                <b-col sm="8">
                  <b-form-textarea
                    id="remark-input"
                    name="remark-input"
                    v-model="form.remark"
                    rows="3"
                    max-rows="6"
                    :disabled="isPointGrant"
                  ></b-form-textarea>
                </b-col>
              </b-row>

              <div
                v-if="hasOcrData"
                class="ocr-data-container"
              >
                <b-row class="align-items-center mb-2 ocr-section-head no-gutters">
                  <b-col>
                    <h5 class="ocr-title mb-0">ข้อมูลจาก OCR</h5>
                  </b-col>
                  <b-col cols="12" sm="auto" class="text-sm-right mt-2 mt-sm-0">
                    <span class="ocr-overall-confidence text-nowrap">
                      ความมั่นใจ (OCR): {{ ocrOverallConfidenceDisplay }}
                    </span>
                  </b-col>
                </b-row>
                <div class="table-responsive">
                  <table class="table table-bordered table-sm mb-0">
                    <thead class="thead-light">
                      <tr>
                        <th style="width: 35%">รายการ</th>
                        <th>ข้อมูล</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(row, index) in ocrRows"
                        :key="`ocr-row-${index}`"
                      >
                        <td>{{ row.field }}</td>
                        <td class="ocr-value">{{ row.value }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div
                v-if="form.duplicate_receipt && form.duplicate_receipt.length"
                class="duplicate-receipt-container"
              >
                <div class="duplicate-receipt-wrapper">
                  <h2 class="title">
                    {{ isTransferSlip ? "พบรายการสลิปซ้ำ" : "พบรายการใบเสร็จซ้ำ" }}
                  </h2>

                  <b-row>
                    <b-col
                      v-for="duplicate in form.duplicate_receipt"
                      :key="duplicate.id"
                      sm="3"
                    >
                      <a :href="duplicate.receipt_image" target="_blank">
                        <img
                          :src="duplicate.receipt_image"
                          alt="duplicate_receipt_image"
                          class="duplicate-receipt-image"
                        />
                      </a>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
          </b-row>
        </form>

        <template #modal-footer="{ ok, cancel }">
          <div class="d-flex w-100 align-items-center">
            <b-button
              v-if="is_approve && isSuperAdmin && !isPointGrant"
              variant="danger"
              @click="handleRevertApprove"
            >
              {{
                $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.BTN_REVERT_APPROVE")
              }}
            </b-button>
            <div class="ml-auto">
              <b-button class="mr-2" @click="cancel()">
                {{ $t("PAGE.DEFAULT.FORM.BTN_CANCEL") }}
              </b-button>
              <b-button
                v-if="!isPointGrant"
                variant="primary"
                :disabled="is_checking_verify_code"
                @click="ok()"
              >
                {{ $t("PAGE.DEFAULT.FORM.BTN_SUBMIT") }}
              </b-button>
            </div>
          </div>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { validationMixin } from "vuelidate";
import _ from "lodash";
import { required } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import {
  PAGINATION_CUSTOMER_CAMPAIGN_RECEIPT,
  FIND_CUSTOMER_CAMPAIGN_RECEIPT,
  UPDATE_CUSTOMER_CAMPAIGN_RECEIPT,
  REVERT_APPROVE_CUSTOMER_CAMPAIGN_RECEIPT,
  SET_PAGINATION,
  SET_IS_CLEAR_PAGINATION,
  CLEAR_PAGINATION,
  CHECK_RECEIPT_CODE_EXIST
} from "@/core/services/store/customer_campaign_receipt.module";
import { GET_UNAPPROCED_REASON } from "@/core/services/store/unapproced_reason.module";
import { GET_RECEIPT_TYPE } from "@/core/services/store/receipt_type.module";
import ApiService from "@/core/services/api.service";
import { en, th } from "vuejs-datepicker/dist/locale";
import datePicker from "vue-bootstrap-datetimepicker";

export default {
  name: "CustomerCampaignReceipt",
  mixins: [validationMixin],
  props: {
    campaign_id: [String, Number],
    is_redeem_reward: [String, Number],
    isTransferSlip: { type: Boolean, default: false }
  },
  components: {
    datePicker
  },
  data() {
    return {
      from: null,
      to: null,
      filter_is_approve: 99,
      is_select_not_approve: false,
      is_approve: false,
      is_checking_verify_code: false,
      is_select_reason_other: false,
      options: {
        useCurrent: false,
        locale: "th",
        icons: {
          time: "fas fa-clock",
          date: "far fa-calendar",
          up: "fas fa-arrow-up",
          down: "fas fa-arrow-down",
          previous: "fas fa-chevron-left",
          next: "fas fa-chevron-right",
          today: "fas fa-calendar-check",
          clear: "far fa-trash-alt",
          close: "far fa-times-circle"
        }
      },
      option_radio: [],
      fields: [
        {
          key: "id",
          label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.INDEX")}`,
          key_table: "customer_campaign_receipt.id",
          sortable: false,
          isFilter: false,
          tdClass: "idField"
        },
        {
          key: "created_at",
          label: `${this.$t("PAGE.CAMPAIGN.TABLE.FIELDS.CREATED_AT")}`,
          key_table: "customer_campaign_receipt.created_at",
          sortable: true,
          isFilter: false
        },
        {
          key: "customer_fullname",
          label: `${this.$t("PAGE.CAMPAIGN.TABLE.FIELDS.CUSTOMER")}`,
          key_table: "customer_fullname",
          sortable: false,
          isFilter: true
        },
        {
          key: "customer_campaign_receipt.type",
          label: "ประเภทรายการ",
          key_table: "customer_campaign_receipt.type",
          sortable: false,
          isFilter: false
        },
        {
          key: "receipt_type_name",
          label: `${this.$t("PAGE.CAMPAIGN.TABLE.FIELDS.RECEIPT_TYPE")}`,
          key_table: "receipt_type_name",
          sortable: true,
          isFilter: true
        },
        {
          key: "customer_campaign_receipt.is_approve",
          label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.TITLE")}`,
          key_table: "customer_campaign_receipt.is_approve",
          sortable: true,
          isFilter: true
        },
        {
          key: "customer_campaign_receipt.point",
          label: `${this.$t("PAGE.CAMPAIGN.TABLE.FIELDS.POINT")}`,
          thClass: "text-right",
          key_table: "customer_campaign_receipt.point",
          sortable: true,
          isFilter: true
        },
        {
          key: "customer_campaign_receipt.verify_code",
          label: `${this.$t("PAGE.CAMPAIGN.TABLE.FIELDS.VERIFY_CODE")}`,
          key_table: "customer_campaign_receipt.verify_code",
          sortable: true,
          isFilter: true
        },
        {
          key: "customer_campaign_receipt.remark",
          label: `${this.$t("PAGE.CAMPAIGN.TABLE.FIELDS.REMARK")}`,
          key_table: "customer_campaign_receipt.remark",
          sortable: true,
          isFilter: true
        },
        {
          key: "action",
          label: `${this.$t("PAGE.DEFAULT.TABLE.FIELDS.ACTION.TITLE")}`,
          sortable: false,
          isFilter: false,
          tdClass: "actionField"
        }
      ],
      select: [
        "customer_campaign_receipt.id",
        "customer.first_name",
        "customer.last_name",
        "receipt_type.name as receipt_type_name",
        "customer_campaign_receipt.ocr_store_name as bank_name",
        "customer_campaign_receipt.bank_code",
        "customer_campaign_receipt.ocr_json",
        "customer_campaign_receipt.point",
        "customer_campaign_receipt.verify_code",
        "customer_campaign_receipt.remark",
        "customer_campaign_receipt.is_approve",
        "customer_campaign_receipt.created_at",
        "customer_campaign_receipt.status_id",
        "customer_campaign_receipt.type",
        "customer_campaign_receipt.ocr_receipt_number"
      ],
      include: [],
      paginationOptions: [25, 50, 100, 200],
      isBusy: false,
      items: [],
      total: 0,
      form: {
        receipt_type_id: null,
        is_approve: 0,
        unapproved_reason_id: null,
        unapproved_reason_remark: null,
        point: null,
        verify_code: null,
        remark: null,
        bank_code: null,
        duplicate_receipt: []
      },
      approval_list: [
        {
          value: 0,
          text: this.$t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.WAITING_APPROVE")
        },
        {
          value: 1,
          text: this.$t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.APPROVED")
        },
        {
          value: 2,
          text: this.$t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.UNAPPROVED")
        }
      ],
      filter_approval_list: [
        {
          value: 99,
          text: this.$t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.ALL")
        },
        {
          value: 0,
          text: this.$t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.WAITING_APPROVE")
        },
        {
          value: 1,
          text: this.$t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.APPROVED")
        },
        {
          value: 2,
          text: this.$t("PAGE.DEFAULT.TABLE.FIELDS.STATUS.UNAPPROVED")
        }
      ],
      receipt_type_list: [],
      master_banks: []
    };
  },
  validations: {
    form: {
      point: {
        required
      }
    }
  },
  watch: {
    isTransferSlip(value) {
      if (value && !this.master_banks.length) {
        this.loadMasterBanks();
      }
    }
  },
  computed: {
    /** Super Admin = user_type_id 1 (Platform admin) — เห็นปุ่มถอนการอนุมัติเฉพาะคนนี้ */
    isSuperAdmin() {
      return this.$store.state.auth.userType === 1;
    },
    /** รายการที่ Staff แจกแต้มผ่าน Admin Tool Mobile ดูได้อย่างเดียว ไม่มีปุ่มถอนการอนุมัติและตกลง */
    isPointGrant() {
      return this.form.type === "point_grant";
    },
    tableFields() {
      if (!this.isTransferSlip) {
        return this.fields;
      }
      return this.fields.map((c) => {
        if (c.key === "receipt_type_name") {
          return {
            ...c,
            key: "bank_name",
            label: "ธนาคาร",
            key_table: "bank_name",
            sortable: false,
            isFilter: false
          };
        }
        return c;
      });
    },
    /** ป้ายประเภทการชำระเงินจาก customer_campaign_receipt.payment_type ('slip'|'cash'|'receipt') */
    paymentTypeDisplay() {
      const labels = {
        slip: "สลิปโอนเงิน",
        cash: "เงินสด",
        receipt: "ใบเสร็จ"
      };
      return labels[this.form.payment_type] || null;
    },
    ocrRows() {
      let rows = [];
      const parsedOcrJson = this.parseOcrJson(this.form.ocr_json);
      if (parsedOcrJson && typeof parsedOcrJson === "object") {
        if (this.isTransferSlipOcrPayload(parsedOcrJson)) {
          return this.buildTransferSlipOcrRows(parsedOcrJson);
        }
        rows = this.buildOrderedOcrRows(parsedOcrJson);
      }

      if (!rows.length) {
        const basicFields = [
          { key: "ocr_receipt_number", label: "เลขที่ใบเสร็จ" },
          { key: "ocr_store_name", label: "merchant - ชื่อสินค้า" },
          { key: "ocr_date", label: "วันที่บนใบเสร็จ" },
          { key: "ocr_raw_text", label: "รายการสินค้า" },
          { key: "ocr_subtotal", label: "ยอดก่อนรวม (บาท)" },
          { key: "ocr_discount", label: "ส่วนลด (บาท)" },
          { key: "ocr_total_amount", label: "ยอดรวมสุทธิ (บาท)" },
          { key: "ocr_method", label: "วิธีอ่านข้อมูล" }
        ];
        for (const item of basicFields) {
          const value = this.form[item.key];
          if (this.hasValue(value)) {
            rows.push({
              field: item.label,
              value: this.formatOcrValue(value, item.key)
            });
          }
        }
      }

      if (!rows.length && this.hasValue(this.form.ocr_json)) {
        rows.push({
          field: "ข้อมูล OCR",
          value: this.formatOcrValue(this.form.ocr_json)
        });
      }

      return rows;
    },
    hasOcrData() {
      if (!this.hasOcrSourceData()) {
        return false;
      }
      return this.ocrRows.length > 0;
    },
    ocrOverallConfidenceDisplay() {
      const parsed = this.parseOcrJson(this.form.ocr_json);
      return this.formatConfidenceCell(this.getOverallConfidenceNumeric(parsed));
    },
    isClearPagination: {
      get() {
        return this.$store.state.customer_campaign_receipt.isClearPagination;
      },
      set(value) {
        this.$store.commit(SET_IS_CLEAR_PAGINATION, {
          isClearPagination: value
        });
      }
    },
    pagination: {
      get() {
        return this.$store.state.customer_campaign_receipt.pagination;
      },
      set(value) {
        this.$store.commit(SET_PAGINATION, { pagination: value });
      }
    }
  },
  mounted() {
    if (this.isClearPagination) {
      this.$store.commit(CLEAR_PAGINATION);
    }

    this.isClearPagination = true;
    this.getReceiptType();
    if (this.isTransferSlip) {
      this.loadMasterBanks();
    }
    this.fetchData();
  },
  methods: {
    loadMasterBanks() {
      ApiService.setHeader();
      ApiService.getParams("master/banks")
        .then((response) => {
          const data = response && response.data ? response.data.data : null;
          this.master_banks = Array.isArray(data) ? data : [];
        })
        .catch((error) => {
          this.master_banks = [];
          // eslint-disable-next-line no-console
          console.error("loadMasterBanks error", error);
        });
    },
    resolveBankCode(rawBank) {
      if (!this.hasValue(rawBank)) {
        return null;
      }
      const normalized = String(rawBank)
        .toLowerCase()
        .replace(/ธนาคาร/g, "")
        .replace(/ธ\./g, "")
        .replace(/bank/g, "")
        .replace(/[\s.]/g, "");

      const aliasMap = {
        kbank: ["กสิกร", "kasikorn", "kbank"],
        scb: ["ไทยพาณิชย์", "siamcommercial", "scb"],
        bbl: ["กรุงเทพ", "bangkok", "bbl"],
        ktb: ["กรุงไทย", "krungthai", "ktb"],
        bay: ["กรุงศรี", "krungsri", "ayudhya", "bay"],
        tmb: ["ทหารไทย", "ธนชาต", "thanachart", "ttb", "tmb"],
        gsb: ["ออมสิน", "governmentsavings", "gsb"],
        baac: ["เกษตร", "ธ.ก.ส", "ธกส", "baac"],
        uob: ["ยูโอบี", "uob"],
        cimb: ["ซีไอเอ็มบี", "cimb"],
        kkp: ["เกียรตินาคิน", "kiatnakin", "kkp"],
        lhbank: ["แลนด์แอนด์เฮ้าส์", "lhbank", "lh"],
        tisco: ["ทิสโก้", "tisco"],
        ghb: ["อาคารสงเคราะห์", "ghb"]
      };

      for (const value of Object.keys(aliasMap)) {
        const aliases = aliasMap[value];
        const isMatch = aliases.some((alias) => {
          const normalizedAlias = String(alias)
            .toLowerCase()
            .replace(/[\s.]/g, "");
          return (
            normalizedAlias.length > 0 && normalized.includes(normalizedAlias)
          );
        });
        if (isMatch) {
          return value;
        }
      }

      return null;
    },
    bankTextFromCode(code) {
      if (!this.hasValue(code)) {
        return null;
      }
      const found = this.master_banks.find((b) => b.value === code);
      return found && this.hasValue(found.text) ? found.text : null;
    },
    resolveBankName(rawBank) {
      if (!this.hasValue(rawBank)) {
        return "-";
      }
      const matchedText = this.bankTextFromCode(this.resolveBankCode(rawBank));
      if (this.hasValue(matchedText)) {
        return matchedText;
      }
      return this.hasValue(rawBank) ? String(rawBank) : "-";
    },
    getRowBankName(item) {
      const savedText = this.bankTextFromCode(item.bank_code);
      if (this.hasValue(savedText)) {
        return savedText;
      }
      const parsed = this.parseOcrJson(item.ocr_json);
      const bankFrom = parsed
        ? this.getFirstValue(parsed, ["bank_from"])
        : null;
      const bankTo = parsed ? this.getFirstValue(parsed, ["bank_to"]) : null;
      // Prefer whichever field resolves to a known bank — app slips such as
      // "make" only expose the bank as bank_to (กสิกรไทย).
      const matchedCode =
        this.resolveBankCode(bankFrom) ||
        this.resolveBankCode(bankTo) ||
        this.resolveBankCode(item.bank_name);
      if (matchedCode) {
        return this.bankTextFromCode(matchedCode) || "-";
      }
      const raw = [bankFrom, bankTo, item.bank_name].find((v) =>
        this.hasValue(v)
      );
      return this.hasValue(raw) ? String(raw) : "-";
    },
    hasOcrSourceData() {
      if (this.hasValue(this.form.ocr_json)) {
        return true;
      }
      const ocrColumnKeys = [
        "ocr_receipt_number",
        "ocr_store_name",
        "ocr_date",
        "ocr_raw_text",
        "ocr_subtotal",
        "ocr_discount",
        "ocr_total_amount",
        "ocr_method"
      ];
      if (ocrColumnKeys.some((k) => this.hasValue(this.form[k]))) {
        return true;
      }
      const oc = Number(this.form.ocr_confidence);
      return Number.isFinite(oc) && oc > 0;
    },
    normalizeConfidenceNumber(raw) {
      if (raw === null || raw === undefined || raw === "") {
        return null;
      }
      const n = Number(raw);
      if (!Number.isFinite(n)) {
        return null;
      }
      const scaled = n <= 1 ? Math.round(n * 100) : Math.round(n);
      return Math.max(0, Math.min(100, scaled));
    },
    getOverallConfidenceNumeric(payload) {
      if (
        payload &&
        payload.confidence &&
        this.hasValue(payload.confidence.overall)
      ) {
        const v = this.normalizeConfidenceNumber(payload.confidence.overall);
        if (v !== null) {
          return v;
        }
      }
      return this.normalizeConfidenceNumber(this.form.ocr_confidence);
    },
    formatConfidenceCell(pct) {
      if (pct === null || pct === undefined) {
        return "—";
      }
      return `${pct}%`;
    },
    hasValue(value) {
      if (value === null || value === undefined) {
        return false;
      }
      if (typeof value === "string") {
        return value.trim() !== "";
      }
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      if (typeof value === "object") {
        return Object.keys(value).length > 0;
      }
      return true;
    },
    parseOcrJson(ocrJson) {
      if (!this.hasValue(ocrJson)) {
        return null;
      }
      if (typeof ocrJson === "object") {
        return ocrJson;
      }
      if (typeof ocrJson === "string") {
        try {
          return JSON.parse(ocrJson);
        } catch (error) {
          return null;
        }
      }
      return null;
    },
    getOcrLabelByKey(key) {
      const normalizeKey = String(key || "").toLowerCase();
      const labelMap = {
        merchant_name: "ชื่อร้าน",
        store_name: "ชื่อร้าน",
        shop_name: "ชื่อร้าน",
        branch_name: "สาขา",
        receipt_number: "เลขที่ใบเสร็จ",
        invoice_number: "เลขที่ใบเสร็จ",
        bill_no: "เลขที่ใบเสร็จ",
        receipt_date: "วันที่บนใบเสร็จ",
        date: "วันที่บนใบเสร็จ",
        purchase_date: "วันที่บนใบเสร็จ",
        receipt_time: "เวลา",
        time: "เวลา",
        total_amount: "ยอดรวมสุทธิ (บาท)",
        grand_total: "ยอดรวมสุทธิ (บาท)",
        total: "ยอดรวมสุทธิ (บาท)",
        subtotal: "ยอดก่อนรวม (บาท)",
        tax_amount: "ภาษีมูลค่าเพิ่ม (บาท)",
        tax: "ภาษีมูลค่าเพิ่ม (บาท)",
        vat: "ภาษีมูลค่าเพิ่ม (บาท)",
        discount: "ส่วนลด (บาท)",
        payment_method: "วิธีชำระเงิน",
        cashier_name: "พนักงานแคชเชียร์",
        currency: "สกุลเงิน",
        items: "รายการสินค้า",
        line_items: "รายการสินค้า",
        name: "ชื่อสินค้า",
        quantity: "จำนวน",
        qty: "จำนวน",
        unit_price: "ราคา/ชิ้น (บาท)",
        amount: "ยอดรวมรายการ (บาท)",
        line_total: "ยอดรวมรายการ (บาท)",
        sku: "รหัสสินค้า"
      };

      return labelMap[normalizeKey] || key;
    },
    buildOrderedOcrRows(payload) {
      const merchant = payload && payload.merchant ? payload.merchant : {};
      const lineItems = payload.line_items || payload.items;
      const rows = [];

      const orderedFields = [
        {
          field: "เลขที่ใบเสร็จ",
          value: this.getFirstValue(payload, [
            "receipt_number",
            "invoice_number",
            "bill_no"
          ]),
          key: "receipt_number"
        },
        {
          field: "merchant - ชื่อสินค้า",
          value: this.getFirstValue(merchant, [
            "name",
            "store_name",
            "shop_name"
          ]),
          key: "merchant_name"
        },
        {
          field: "merchant - branch",
          value: this.getFirstValue(merchant, ["branch", "branch_name"]),
          key: "branch"
        },
        {
          field: "วันที่บนใบเสร็จ",
          value: this.getFirstValue(payload, [
            "receipt_date",
            "date",
            "purchase_date"
          ]),
          key: "receipt_date"
        },
        {
          field: "เวลา",
          value: this.getFirstValue(payload, ["receipt_time", "time"]),
          key: "receipt_time"
        },
        {
          field: "ชื่อผู้รับบริการ",
          value: this.extractOcrCustomerName(payload),
          key: "customer_name"
        },
        {
          field: "รายการสินค้า",
          value: this.formatOcrLineItems(lineItems),
          key: "line_items"
        },
        {
          field: "ยอดก่อนรวม (บาท)",
          value: this.getFirstValue(payload, ["subtotal"]),
          key: "subtotal"
        },
        {
          field: "ส่วนลด (บาท)",
          value: this.getFirstValue(payload, ["discount"]),
          key: "discount"
        },
        {
          field: "ยอดรวมสุทธิ (บาท)",
          value: this.getFirstValue(payload, [
            "total_amount",
            "grand_total",
            "total"
          ]),
          key: "total_amount"
        }
      ];

      orderedFields.forEach((item) => {
        if (!this.hasValue(item.value)) {
          return;
        }
        rows.push({
          field: item.field,
          value: this.formatOcrValue(item.value, item.key)
        });
      });

      return rows;
    },
    isTransferSlipOcrPayload(payload) {
      if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
        return false;
      }
      const slipKeys = [
        "bank_from",
        "bank_to",
        "sender_name",
        "receiver_name",
        "receiver_account",
        "reference_number",
        "transfer_date",
        "transfer_date_raw",
        "transfer_time"
      ];
      return slipKeys.some((key) => this.hasValue(payload[key]));
    },
    buildTransferSlipOcrRows(payload) {
      const rows = [];
      const orderedFields = [
        {
          field: "ธนาคารต้นทาง",
          value: this.getFirstValue(payload, ["bank_from"])
        },
        {
          field: "ธนาคารปลายทาง",
          value: this.getFirstValue(payload, ["bank_to"])
        },
        {
          field: "ชื่อผู้โอน",
          value: this.getFirstValue(payload, ["sender_name"])
        },
        {
          field: "ชื่อผู้รับเงิน",
          value: this.getFirstValue(payload, ["receiver_name"])
        },
        {
          field: "เลขที่บัญชีผู้รับ",
          value: this.getFirstValue(payload, ["receiver_account"])
        },
        {
          field: "เลขที่อ้างอิง",
          value: this.getFirstValue(payload, ["reference_number"])
        },
        {
          field: "วันที่โอน",
          value: this.getFirstValue(payload, [
            "transfer_date",
            "transfer_date_raw"
          ])
        },
        {
          field: "เวลาโอน",
          value: this.getFirstValue(payload, ["transfer_time"])
        },
        {
          field: "จำนวนเงิน (บาท)",
          value: this.getFirstValue(payload, ["amount"]),
          key: "amount"
        },
        {
          field: "ค่าธรรมเนียม (บาท)",
          value: this.getFirstValue(payload, ["fee"]),
          key: "amount"
        }
      ];

      orderedFields.forEach((item) => {
        if (!this.hasValue(item.value)) {
          return;
        }
        rows.push({
          field: item.field,
          value: this.formatOcrValue(item.value, item.key)
        });
      });

      return rows;
    },
    getFirstValue(source, keys) {
      if (!source || typeof source !== "object") {
        return null;
      }
      for (const key of keys) {
        if (this.hasValue(source[key])) {
          return source[key];
        }
      }
      return null;
    },
    getFirstNestedValue(source, paths) {
      if (!source || typeof source !== "object") {
        return null;
      }
      for (const path of paths) {
        const keys = String(path || "").split(".");
        let current = source;
        for (const key of keys) {
          if (!current || typeof current !== "object") {
            current = null;
            break;
          }
          current = current[key];
        }
        if (this.hasValue(current)) {
          return current;
        }
      }
      return null;
    },
    extractOcrCustomerName(payload) {
      return this.getFirstNestedValue(payload, [
        "customer_name",
        "recipient_name",
        "served_by",
        "cashier_name",
        "staff_name",
        "patient_name",
        "client_name",
        "recipient",
        "customer.name",
        "customer.full_name",
        "recipient.name",
        "recipient.full_name",
        "service_recipient.name",
        "service_recipient.full_name"
      ]);
    },
    formatOcrLineItems(lineItems) {
      if (!Array.isArray(lineItems) || !lineItems.length) {
        return null;
      }
      return lineItems
        .map((item, index) => {
          const itemName = this.extractItemName(item, index);
          const qty = this.extractItemQuantity(item);
          const amount = this.extractItemAmount(item);
          const qtyText = this.hasValue(qty) ? String(qty) : "-";
          const amountText = this.hasValue(amount)
            ? this.formatOcrValue(amount, "amount")
            : "-";
          return `${itemName} จำนวน ${qtyText} ราคา ${amountText} .-`;
        })
        .join("\n");
    },
    buildOcrJsonRows(payload, parentPath = "") {
      const rows = [];
      Object.entries(payload).forEach(([key, value]) => {
        if (!this.hasValue(value)) {
          return;
        }
        if (this.shouldHideOcrField(key)) {
          return;
        }

        const label = parentPath
          ? `${parentPath} - ${this.getOcrLabelByKey(key)}`
          : this.getOcrLabelByKey(key);

        if (Array.isArray(value)) {
          if (
            value.length &&
            value.every(
              (item) => item && typeof item === "object" && !Array.isArray(item)
            )
          ) {
            if (["items", "line_items"].includes(String(key).toLowerCase())) {
              const itemLines = value.map((item, index) => {
                const itemName = this.extractItemName(item, index);
                const qty = this.extractItemQuantity(item);
                const amount = this.extractItemAmount(item);
                const qtyText = this.hasValue(qty) ? String(qty) : "-";
                const amountText = this.hasValue(amount)
                  ? this.formatOcrValue(amount, "amount")
                  : "-";
                return `${itemName} - ${qtyText} ${amountText} .-`;
              });
              rows.push({
                field: label,
                value: itemLines.join("\n")
              });
            } else {
              value.forEach((item, index) => {
                rows.push(
                  ...this.buildOcrJsonRows(item, `${label} ${index + 1}`)
                );
              });
            }
          } else {
            rows.push({
              field: label,
              value: value
                .map((item) => this.formatOcrValue(item, key))
                .join(", ")
            });
          }
          return;
        }

        if (typeof value === "object") {
          rows.push(...this.buildOcrJsonRows(value, label));
          return;
        }

        rows.push({
          field: label,
          value: this.formatOcrValue(value, key)
        });
      });

      return rows;
    },
    shouldHideOcrField(key) {
      const normalizedKey = String(key || "").toLowerCase();
      return (
        normalizedKey.includes("confidence") ||
        normalizedKey === "schema_version" ||
        normalizedKey === "receipt_date_raw" ||
        normalizedKey === "transfer_date_raw" ||
        normalizedKey === "notes" ||
        normalizedKey === "currency"
      );
    },
    extractItemName(item, index) {
      const itemNameKeys = [
        "name",
        "item_name",
        "product_name",
        "product",
        "description",
        "title",
        "label",
        "text"
      ];
      for (const key of itemNameKeys) {
        if (this.hasValue(item[key])) {
          return String(item[key]);
        }
      }
      return `รายการที่ ${index + 1}`;
    },
    extractItemQuantity(item) {
      const itemQtyKeys = ["quantity", "qty", "count", "amount_qty"];
      for (const key of itemQtyKeys) {
        if (this.hasValue(item[key])) {
          return item[key];
        }
      }
      return null;
    },
    extractItemAmount(item) {
      const itemAmountKeys = [
        "amount",
        "line_total",
        "total",
        "price",
        "unit_price",
        "subtotal"
      ];
      for (const key of itemAmountKeys) {
        if (this.hasValue(item[key])) {
          return item[key];
        }
      }
      return null;
    },
    formatOcrValue(value, key = "") {
      if (value === null || value === undefined) {
        return "-";
      }
      if (typeof value === "number") {
        if (String(key).toLowerCase().includes("confidence")) {
          return value <= 1 ? `${Math.round(value * 100)}%` : `${value}%`;
        }
        if (this.isAmountField(key)) {
          return value.toLocaleString("th-TH", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
        }
      }
      if (typeof value === "string") {
        const normalizedKey = String(key).toLowerCase();
        if (normalizedKey.includes("confidence")) {
          const numeric = Number(value);
          if (!Number.isNaN(numeric)) {
            return numeric <= 1
              ? `${Math.round(numeric * 100)}%`
              : `${numeric}%`;
          }
        }
        if (this.isAmountField(key)) {
          const numeric = Number(value);
          if (!Number.isNaN(numeric)) {
            return numeric.toLocaleString("th-TH", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
          }
        }
      }
      if (typeof value === "object") {
        return JSON.stringify(value, null, 2);
      }
      return String(value);
    },
    isAmountField(key) {
      const normalizedKey = String(key || "").toLowerCase();
      return [
        "amount",
        "total",
        "price",
        "subtotal",
        "tax",
        "vat",
        "discount",
        "service_charge",
        "line_total",
        "unit_price"
      ].some((keyword) => normalizedKey.includes(keyword));
    },
    isNumber(event) {
      if (
        !(
          event.key === "Enter" ||
          (Number(event.key) >= 0 && Number(event.key) <= 9)
        )
      ) {
        return event.preventDefault();
      }
    },
    getParams() {
      const orderByIndex = this.tableFields.findIndex(
        (item) => item.key === this.pagination.orderBy.toString()
      );
      return {
        page: this.pagination.page.toString(),
        perPage: this.pagination.perPage.toString(),
        orderBy: orderByIndex
          ? this.tableFields[orderByIndex].key_table
          : "created_at",
        isDesc: this.pagination.isDesc.toString(),
        filter: this.pagination.filter.toString(),
        from: this.from,
        to: this.to,
        is_approve: this.filter_is_approve,
        filterBy: `${this.tableFields
          .map((item) => {
            if (item.isFilter) return item.key;
          })
          .filter((item) => !!item)}`,
        select: `${this.select}`,
        include: `${this.include}`,
        campaign_id: this.campaign_id
      };
    },
    getUnapprocedReason() {
      this.$store
        .dispatch(GET_UNAPPROCED_REASON)
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.option_radio = data.data.map((data) => {
              data.value = data.id;
              data.text = data.name;
              return data;
            });
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: `${error}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
        });
    },
    getReceiptType() {
      this.$store
        .dispatch(GET_RECEIPT_TYPE)
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            for (const receipt of data.data) {
              this.receipt_type_list.push({
                text: receipt.name,
                value: receipt.id
              });
            }
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: `${error}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
        });
    },
    sortChange(event) {
      this.pagination.isDesc = event.sortDesc;
      this.pagination.orderBy = event.sortBy;
      this.fetchData();
    },
    searchFilter() {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.fetchData();
          Swal.close();
        }
      });
    },
    checkNotApprove(event) {
      this.is_select_not_approve = event === 2;
      if (event === 2) {
        this.$v.form.point.$model = 0;
        this.getUnapprocedReason();
      }
    },
    checkOtherReason(event) {
      this.is_select_reason_other = event === 99;
    },
    fetchData() {
      this.$store
        .dispatch(PAGINATION_CUSTOMER_CAMPAIGN_RECEIPT, {
          params: this.getParams()
        })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.items = data.data.data;
            this.total = data.data.total;
            if (this.total > 0 && this.items.length < 1) {
              this.$store.commit(CLEAR_PAGINATION);
              this.fetchData();
            }
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              showConfirmButton: true,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
          this.isBusy = false;
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: `${error.error}`,
            showConfirmButton: true,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
          this.isBusy = false;
        });
    },
    downloadData() {
      let params = this.getParams();
      let params_open = "";
      for (var key in params) {
        if (params.hasOwnProperty(key)) {
          if (key !== "page") {
            params_open += "&";
          }
          params_open += `${key}=${params[key]}`;
        }
      }
      window.open(
        `${Vue.axios.defaults.baseURL}/customer_campaign_receipt_excel?${params_open}`,
        "_system"
      );
    },
    openFormModal(id) {
      this.$store
        .dispatch(FIND_CUSTOMER_CAMPAIGN_RECEIPT, { id })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.form = data.data;
            if (!Array.isArray(this.form.duplicate_receipt)) {
              this.form.duplicate_receipt = [];
            }
            this.form.customer_fullname = `${data.data.first_name} ${data.data.last_name}`;
            this.form.receipt_image = `${data.data.receipt_image}`;
            this.form.campaign_id = this.campaign_id;
            if (this.isTransferSlip && !this.hasValue(this.form.bank_code)) {
              const parsed = this.parseOcrJson(this.form.ocr_json);
              const bankFrom = parsed
                ? this.getFirstValue(parsed, ["bank_from"])
                : null;
              const bankTo = parsed
                ? this.getFirstValue(parsed, ["bank_to"])
                : null;
              // Prefer the sender's bank (bank_from). App slips such as "make"
              // (issued by KBank) only expose the bank as bank_to (กสิกรไทย),
              // so fall back to bank_to, then to ocr_store_name, before giving up.
              this.$set(
                this.form,
                "bank_code",
                this.resolveBankCode(bankFrom) ||
                  this.resolveBankCode(bankTo) ||
                  this.resolveBankCode(this.form.ocr_store_name) ||
                  null
              );
            }
            this.is_approve = data.data.is_approve === 1;
            this.checkNotApprove(data.data.is_approve);
            this.checkOtherReason(data.data.unapproved_reason_id);
            this.$bvModal.show("modal-form");
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: `${error}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
        });
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    handleSubmit(bvModalEvt) {
      if (this.form.duplicate_receipt && this.form.duplicate_receipt.length) {
        Swal.fire({
          text: `${this.$t(
            "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.CONFIRM_SUBMIT_WITH_DUPLICATE"
          )}`,
          icon: "warning",
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
          cancelButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_CANCEL")}`
        }).then((result) => {
          if (result.isConfirmed) {
            bvModalEvt.preventDefault();
            this.$v.form.$touch();

            if (this.$v.form.$anyError) {
              return;
            }

            this.handleSave(this.form, this.form.id);
          }
        });
      } else {
        bvModalEvt.preventDefault();
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          return;
        }

        this.handleSave(this.form, this.form.id);
      }
    },
    handleSave(data, id) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.$store
            .dispatch(UPDATE_CUSTOMER_CAMPAIGN_RECEIPT, { id, data })
            .then(({ data }) => {
              Swal.close();

              if (data.status === "success" && data.data) {
                Swal.fire({
                  icon: "success",
                  html: `${this.$t("RESPONSE_MESSAGE.SAVE_DATA_SUCCESS")} <br/>
                  ${
                    data.data === "LINE_TOKEN_AUTHENTICATION_FAILED"
                      ? this.$t(
                          "RESPONSE_MESSAGE.SAVE_DATA_SUCCESS_LINE_TOKEN_AUTH_FAILE"
                        )
                      : ""
                  }
                  `
                });
                this.$v.$reset();
                this.fetchData();
                this.$nextTick(() => {
                  this.$bvModal.hide("modal-form");
                });
              } else if (data.status === "error" && data.error) {
                Swal.fire({
                  icon: "error",
                  text: this.$t("RESPONSE_MESSAGE." + data.error),
                  confirmButtonText: this.$t("PAGE.DEFAULT.FORM.BTN_OK")
                });
              }
            })
            .catch((error) => {
              Swal.close();
              Swal.fire({
                icon: "error",
                text: error,
                confirmButtonText: this.$t("PAGE.DEFAULT.FORM.BTN_OK")
              });
            });
        }
      });
    },
    handleRevertApprove() {
      Swal.fire({
        title: `${this.$t(
          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.CONFIRM_REVERT_APPROVE_TITLE"
        )}`,
        text: `${this.$t(
          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.CONFIRM_REVERT_APPROVE"
        )}`,
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`,
        cancelButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_CANCEL")}`
      }).then((result) => {
        if (!result.isConfirmed) {
          return;
        }
        Swal.fire({
          title: `${this.$t("LOADING")}`,
          allowEscapeKey: false,
          allowOutsideClick: false,
          timer: 36000,
          onOpen: () => {
            Swal.showLoading();
            this.$store
              .dispatch(REVERT_APPROVE_CUSTOMER_CAMPAIGN_RECEIPT, {
                id: this.form.id
              })
              .then(({ data }) => {
                Swal.close();
                if (data.status === "success" && data.data) {
                  Swal.fire({
                    icon: "success",
                    text: `${this.$t("RESPONSE_MESSAGE.SAVE_DATA_SUCCESS")}`
                  });
                  this.$v.$reset();
                  this.fetchData();
                  this.$nextTick(() => {
                    this.$bvModal.hide("modal-form");
                  });
                } else if (data.status === "error" && data.error) {
                  Swal.fire({
                    icon: "error",
                    text: this.$t("RESPONSE_MESSAGE." + data.error),
                    confirmButtonText: this.$t("PAGE.DEFAULT.FORM.BTN_OK")
                  });
                }
              })
              .catch((error) => {
                Swal.close();
                Swal.fire({
                  icon: "error",
                  text: error,
                  confirmButtonText: this.$t("PAGE.DEFAULT.FORM.BTN_OK")
                });
              });
          }
        });
      });
    },
    getLanguage() {
      switch (this.$i18n.locale) {
        case "th":
          return th;
        case "en":
          return en;
        default:
          return th;
      }
    },
    handleVerifyCodeExist(event) {
      if (this.isTransferSlip) {
        return;
      }
      let verifyCode = event.target.value;
      this.is_checking_verify_code = true;
      this.checkVerifyCodeExist(verifyCode);
    },
    checkVerifyCodeExist: _.debounce(function (verifyCode) {
      if (this.isTransferSlip) {
        this.form.duplicate_receipt = [];
        this.is_checking_verify_code = false;
        return;
      }
      this.$store
        .dispatch(CHECK_RECEIPT_CODE_EXIST, {
          verify_code: verifyCode,
          campaign_id: this.campaign_id,
          id: this.form.id
        })
        .then(({ data }) => {
          this.form.duplicate_receipt = data.data;
          this.is_checking_verify_code = false;
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: `${error}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
        });
    }, 300)
  }
};
</script>

<style scoped lang="scss">
.receipt-image {
  width: 100%;
  margin-bottom: 15px;
  border: solid 2px #ddd;
  border-radius: 5px;
  cursor: pointer;
}
.align-center {
  display: flex;
  align-items: center;
}
.align-center label {
  margin: 0;
}

.duplicate-receipt-container {
  margin-top: 30px;
  border-top: solid 1px #ccc;

  .duplicate-receipt-wrapper {
    border: solid 1px #ff0000;
    padding: 15px;
    margin-top: 15px;
    background: #f3f6f9;
    border-radius: 5px;

    .title {
      text-align: left;
      color: #ff0000;
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 15px;
      padding-bottom: 15px;
    }

    .duplicate-receipt-image {
      width: 100%;
    }
  }
}

.ocr-data-container {
  margin-top: 20px;
  border-top: solid 1px #ccc;
  padding-top: 15px;

  .ocr-title {
    text-align: left;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .ocr-value {
    white-space: pre-wrap;
    word-break: break-word;
  }

  .ocr-section-head {
    flex-wrap: wrap;
  }

  .ocr-overall-confidence {
    font-size: 0.95rem;
    font-weight: 600;
    color: #3699ff;
  }
}
</style>
